import { useQuery } from '@tanstack/react-query';
import { authService } from '~/services/auth/auth-service';
import { ENABLE_KLEOS_ROLES } from '~/services/environment/environment';
import { myGlobalPermissionsQuery } from '~/shared/api/myGlobalPermissions.queries';

export function useMyGlobalPermissions() {
  return useQuery({
    ...myGlobalPermissionsQuery(),
    enabled: ENABLE_KLEOS_ROLES && authService.isSignedIn,
  });
}
